import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import Dialog from '@material-ui/core/Dialog';

import Capsule from "../../../components/MyCapsules";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import FirstTimeUserMsg from './firstTimeUserMsg';
import AccessCode from './accessCode';

import channelData from "../../../modals/d_channels";
import {resetChannelState} from "./redux_actions";
import AddCircleIcon from '@material-ui/icons/AddCircle';

import "./applicationDashboard.css";

let applicationDashboard = (props) => {
  let { user } = props.auth.user;
  const [isAccessCodeOpen, setAccessCodeOpen] = useState(false);
  let mySubscriptions = props.userState.mySubscriptions;
  let isSubscribed = Object.keys(mySubscriptions).length;
  let sorted = Object
    .keys(mySubscriptions)
    .length
    ? Object
      .keys(mySubscriptions)
      .sort((a, b) => {
        return (mySubscriptions[a].subscribedOn > mySubscriptions[b].subscribedOn
          ? 1
          : -1)
      })
    : null;
  let sorted_products = sorted
    ? sorted.map(id => {
      return id;
    })
    : null;
  props.resetChannelState();
  return <div className="channelDashboardCntr scrollbar" style={{
    width: '100%'
  }}>
    <Header active='myCapsule' />
    <div className="channelsCntr">
      {sorted
        ? <div>
          <div
            className='capsule-cntr'
            style={{
              borderTop: 0,
              fontSize: "1.5rem"
            }}>My Modules</div>
          {buildappDashboard(sorted_products, channelData)}
          <div style={{float:'right', margin:'1rem 2rem'}} onClick={()=>{setAccessCodeOpen(true)}}>
            <AddCircleIcon style={{fontSize:40, fill:'#7CBA00'}}/>
          </div>
          </div>
        : <FirstTimeUserMsg user={user} />}
    </div>
    <Footer />
    <Dialog open={isAccessCodeOpen} onClose={()=>{setAccessCodeOpen(false)}}>
      <AccessCode user={user} onSuccess={()=>{setAccessCodeOpen(false)}} onFailure={()=>{setAccessCodeOpen(false)}}/>
    </Dialog>
  </div>
}

const buildappDashboard = (sorted_products, channelData) => {
  return sorted_products.map(key => {
    let channel = channelData[key];
    if(channel){return <Capsule key={key} cardData={channel} buttonText="Run Session" />}
    return null;
  });
};


const mapStateToProps = state => ({ userState: state.userState, auth: state.auth, channelState: state.channelState });
function matchDispatchToProps(dispatch) {
  return bindActionCreators({resetChannelState}, dispatch);
}
export default withRouter(connect(mapStateToProps, matchDispatchToProps)(applicationDashboard));